import { render, staticRenderFns } from "./RightsHolderDetail.vue?vue&type=template&id=657c9289&scoped=true&"
import script from "./RightsHolderDetail.vue?vue&type=script&lang=js&"
export * from "./RightsHolderDetail.vue?vue&type=script&lang=js&"
import style0 from "./RightsHolderDetail.vue?vue&type=style&index=0&id=657c9289&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c9289",
  null
  
)

export default component.exports